module.exports = __webpack_public_path__ + "static/img/money1.511febb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/careers/icons/money1.png
// module id = Qtq2
// module chunks = 2